var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Coordinates",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M22,22.087V6.718L16,3.68l-.659-.386a4.433,4.433,0,0,0-7.023-.875A4.565,4.565,0,0,0,7,5.642c0,.112.024.222.031.333L1,2.92V18.29l6,3.038.716.362.784-.316,6.715-2.721ZM20.5,7.657V19.629L16,17.351V5.378ZM9.379,3.493a2.978,2.978,0,0,1,4.242,0,3.041,3.041,0,0,1,.636.955l.03.076c.01.026.015.053.024.079A2.879,2.879,0,0,1,14.5,5.642a3.037,3.037,0,0,1-.879,2.148L11.5,9.938,9.379,7.79A3.085,3.085,0,0,1,9,7.324c-.02-.03-.032-.064-.05-.093a3.021,3.021,0,0,1-.228-.437A3.072,3.072,0,0,1,8.5,5.642,3.04,3.04,0,0,1,9.379,3.493ZM2.5,17.351V5.378L7,7.657V19.629Zm6-8.3,3,3.038,3-3.038v8.259l-6,2.43Z",
    transform: "translate(-1 -1.087)",
    fill: "#707070"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.391,
    cy: 1.391,
    rx: 1.391,
    ry: 1.391,
    transform: "translate(9.271 2.769)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.d0524dc14a6c611ad064438f1009f22b.svg";
export { ForwardRef as ReactComponent };